export default __webpack_public_path__ + "static/media/heart.ceb3fbdb.svg";